<template>

	<div class="layout-topbar">
			<button class="p-link layout-menu-button layout-topbar-icon" @click="onMenuButtonClick">
				<i class="pi pi-bars"></i>
			</button>			
			<a class="logo-item" @click="$gotoIntro()" href="#">
				<img alt="logo" src="/logo2.svg" class="logo-image2 p-mx-2" />
			</a>			
			<ul class="topbar-menu">
				<li :class="[{'active-topmenuitem fadeInDown': activeTopbarItem === 'settings'}]">					
					<Button v-if="$store.state.cart&&$store.state.cart.totalItems>0" class="p-button-primary p-my-2" icon="pi pi-shopping-cart"
						:label='""+ $store.state.cart.totalItems' 
						@click="gotoShoppingCart()">						
					</Button>
				</li>
			</ul>
	</div>

</template>

<script>
	export default {	
		emits: ['menubutton-click', 'topbar-menubutton-click', 'topbar-item-click', 'right-menubutton-click'],
		props: {
			title:String,
			topbarMenuActive: Boolean,
			activeTopbarItem: String,
			inlineUser: Boolean,
		},
		methods: {
			onMenuButtonClick(event) {
				this.$emit('menubutton-click', event);
			},
			onTopbarMenuButtonClick(event) {
				this.$emit('topbar-menubutton-click', event);
			},
			onRightMenuButtonClick(event) {
				this.$emit('right-menubutton-click', event);
			},
			gotoShoppingCart(){
				this.$router.push({path: "/cart"});  
			},
		}
	}
</script>

<style lang="scss">

	.layout-wrapper .layout-topbar .topbar-menu > li > button {
		position: relative;
		display: block;
		text-align: center;
		border-radius: 10%;
		transition: background-color 0.2s, box-shadow 0.2s;
	}

	.topbar-icon2 {
                        width: auto;
                        height: 45px;
                        line-height: 45px;
                        text-align: center;
                        font-size: 1.2em;
                        vertical-align: middle;
						cursor: pointer;
						
    }

	.logo-image2{
		//height: 25px !important;
		//widows: 25px !important;
		//max-width: 25px !important;
		//max-height: 25px !important;
		max-height: 80% !important;
		vertical-align: middle;
		//display: none;
	}
	.logo-image{
		display: none !important;		
	}
	.logo-item {
		vertical-align: middle;
		display: inline !important;		
		font-size:17px;
		//color: #252529;
		color: #ffffff;
		font-weight:bold;
		text-align: center;
		line-height: 2;
	}

	@media screen and (min-width: 896px) {
		.logo-item {
			//font-size:23px;
			//color: #252529;
			color: #ffffff;
		}

		.logo-image{
			display: inline !important;
		}

		.logo-image2{
			//height: 25px !important;
			//widows: 25px !important;
			//max-width: 25px !important;
			//max-height: 25px !important;
			max-height: 80% !important;
			display: inline !important;
		}
  
	}
</style>
